import { Button } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import { AssetsBaseUrl } from '../../assets';
import { EExtraMode } from '../types';

interface IExtraModeItemProps {
  mode: EExtraMode;
  onSelect: () => void;
}

export default function ExtraModeItem({ mode, onSelect }: Readonly<IExtraModeItemProps>) {
  const { t } = useTranslation();

  const imgSrc = `${AssetsBaseUrl}/feature/extra-modes/${mode}Mode.png`;
  const title = t(`Exercise.ExtraModes.${mode}.Title`);
  const description = t(`Exercise.ExtraModes.${mode}.Description`);
  const buttonLabel = t(`Exercise.ExtraModes.${mode}.Action`);
  return (
    <li className="extra-mode-item">
      <img src={imgSrc} alt={title} />
      <h3>{title}</h3>
      <p>{description}</p>
      <Button label={buttonLabel} onClick={() => onSelect()} />
    </li>
  );
}
